import { jsx as _jsx } from "react/jsx-runtime";
import { byPrefixAndName } from '@awesome.me/kit-33eaf73f2e/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TableSortLabel } from '@mui/material';
import { useCallback, useContext } from 'react';
import SortContext from '@/contexts/SortContext';
const SortLabel = ({ children, field }) => {
    const { descend, orderBy, setDescend, setOrderBy } = useContext(SortContext);
    const handleSort = useCallback(() => {
        if (field !== orderBy) {
            setOrderBy(field);
            setDescend(false);
        }
        else
            setDescend(prevState => !prevState);
    }, [field, orderBy, setDescend, setOrderBy]);
    const IconComponent = useCallback((props) => {
        const key = field === orderBy ? 'arrow-down-long' : 'arrow-down-arrow-up';
        return (_jsx("div", { className: "test", children: _jsx(FontAwesomeIcon, { icon: byPrefixAndName.far[key], ...props }) }));
    }, [field, orderBy]);
    return (_jsx(TableSortLabel, { active: field === orderBy, "data-testid": `${field}-sort-label`, direction: descend ? 'desc' : 'asc', IconComponent: IconComponent, onClick: handleSort, 
        // @ts-expect-error data-testid is valid
        slotProps: { icon: { 'data-testid': `${field}-sort-icon` } }, children: children }));
};
export default SortLabel;
